import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { RuleTypePipe } from '@app/criterion-addition/shared/pipes/rule-type.pipe';
import { HasRuleFiltersPipe } from '@app/criterion-addition/shared/pipes/has-rule-filters.pipe';
import { RuleFiltersComponent } from '@app/criterion-addition/shared/modules/rules-table/components/rule-filters/rule-filters.component';
import { DestinationLabelPipe } from '@app/criterion-addition/shared/pipes/destination-label.pipe';
import { DestinationTargetPipe } from '@app/criterion-addition/shared/pipes/destination-target.pipe';
import { DestinationTypePipe } from '@app/criterion-addition/shared/pipes/destination-type.pipe';
import { RuleFilterOperandPipe } from '@app/criterion-addition/shared/pipes/rule-filter-operand.pipe';
import { RuleFilterOperationPipe } from '@app/criterion-addition/shared/pipes/rule-filter-operation.pipe';
import { DestinationWarningsComponent } from '@app/criterion-addition/shared/components/destination-warnings/destination-warnings.component';
import { DestinationCreateTooltipComponent } from '@app/criterion-addition/shared/components/destination-create-tooltip/destination-create-tooltip.component';

@NgModule({
  imports: [CommonModule, NzTagModule, TranslateModule, NzToolTipModule],
  declarations: [
    RuleTypePipe,
    RuleFilterOperandPipe,
    RuleFilterOperationPipe,
    DestinationLabelPipe,
    DestinationTargetPipe,
    DestinationTypePipe,
    HasRuleFiltersPipe,

    RuleFiltersComponent,
    DestinationWarningsComponent,
    DestinationCreateTooltipComponent,
  ],
  exports: [
    RuleTypePipe,
    RuleFilterOperandPipe,
    RuleFilterOperationPipe,
    DestinationLabelPipe,
    DestinationTargetPipe,
    DestinationTypePipe,
    HasRuleFiltersPipe,

    RuleFiltersComponent,
    DestinationWarningsComponent,
    DestinationCreateTooltipComponent,
  ],
})
export class CriterionAdditionSharedModule {}
